import React from "react";
import { MessageCircle, Sparkles } from "lucide-react";
import { useConsultant } from "./ConsultantContext";
import ConsultantChatPanel from "./ConsultantChatPanel";
import "./consultant.css";

const FloatingConsultant = () => {
  const { isAvailable, isOpen, open } = useConsultant();
  if (!isAvailable) return null;

  return (
    <div className="consultant-root" data-testid="consultant-root">
      {isOpen ? <ConsultantChatPanel /> : (
        <button
          type="button"
          className="consultant-bubble"
          onClick={open}
          aria-label="Abrir Consultor SIGER"
          title="Consultor SIGER"
        >
          <MessageCircle size={26} />
          <span className="consultant-bubble__spark"><Sparkles size={12} /></span>
        </button>
      )}
    </div>
  );
};

export default FloatingConsultant;

